module.exports = __webpack_public_path__ + "static/media/icons-alt.7eaee4bb.svg";